import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import {
    webStyle
} from "../../../../utils";

export const COMPOSER_ATTACHMENT_MAX_ROWS = 2;

const stylesheet = StyleSheet.create({
    measure: {
        pointerEvents: "none",
        flexDirection: "row",
        position: "absolute",
        flexWrap: "wrap",
        opacity: 0,
        start: 0,
        end: 0,
        top: 0,
        ...webStyle({
            visibility: "hidden"
        })
    },
    container: {
        position: "relative",
        flexShrink: 1,
        flexGrow: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
}) => {
    const styles = {
        measure: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
